import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function TimerIcon({ color, className }) {
    return (
        <svg
            className={classNames([styles.container, { [className]: className !== null }])}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="23"
            viewBox="0 0 20 23"
        >
            <path
                d="M9.90352 20.3963C8.93123 20.4001 7.96778 20.2113 7.0687 19.8407C6.16913 19.4699 5.35181 18.9244 4.66389 18.2358C3.97598 17.5471 3.43108 16.7289 3.06065 15.8284C2.69022 14.9279 2.50158 13.9628 2.50566 12.9889L2.50562 12.9867C2.48802 12.0113 2.67023 11.0427 3.04098 10.1406C3.41174 9.23849 3.96319 8.42198 4.66132 7.74144L4.66135 7.74147L4.66322 7.73954C5.34264 7.04056 6.15788 6.48831 7.05867 6.11684C7.95945 5.74536 8.9267 5.56253 9.90077 5.57962L9.90077 5.57968L9.9043 5.57962C10.8787 5.56226 11.8463 5.74496 12.7475 6.11644C13.6486 6.48792 14.4642 7.04031 15.1438 7.73954L15.1438 7.73956L15.1458 7.74147C15.8442 8.42184 16.3961 9.23827 16.7672 10.1404C17.1383 11.0425 17.3208 12.0112 17.3034 12.9867L17.3034 12.9889C17.3075 13.9628 17.1188 14.9279 16.7484 15.8284C16.378 16.7289 15.8331 17.5471 15.1452 18.2358C14.4572 18.9244 13.6399 19.4699 12.7403 19.8407C11.8413 20.2113 10.8778 20.4001 9.90552 20.3963C9.90539 20.3963 9.90525 20.3963 9.90511 20.3963M9.90352 20.3963L9.90511 20.3963M9.90352 20.3963L9.90394 20.3963H9.90511M9.90352 20.3963L9.90511 20.3963M6.80357 2.50357V2.60357H6.90357L12.9035 2.60357H13.0035V2.50357V1V0.9L12.9035 0.9L6.90357 0.9L6.80357 0.9V1V2.50357ZM9.05353 13.6911V13.7911H9.15353H10.6555H10.7555V13.6911V7.93246V7.83246H10.6555L9.15353 7.83246H9.05353V7.93246V13.6911ZM9.90409 22.0999L9.96556 22.0995L9.96629 22.098C11.1562 22.0972 12.3337 21.8533 13.4265 21.3811C15.6075 20.446 17.3453 18.7064 18.2793 16.5232C18.7615 15.4094 19.0071 14.2074 19.0004 12.9935C19.0303 11.8116 18.8103 10.6367 18.3548 9.54585L18.3543 9.54467C17.9798 8.67913 17.4763 7.87564 16.8613 7.16149L18.0758 5.95143L18.1467 5.88075L18.076 5.80991L17.0256 4.75842L16.9548 4.68757L16.884 4.75845L15.6739 5.97084C14.9061 5.31891 14.0317 4.80399 13.089 4.44884C12.071 4.0649 10.9912 3.87176 9.90347 3.87907C8.69047 3.87225 7.48931 4.11808 6.37632 4.60094C4.19538 5.53606 2.45771 7.27563 1.52365 9.45884L1.52359 9.45899C1.04816 10.5752 0.803076 11.7761 0.803076 12.9895C0.803076 14.2029 1.04816 15.4038 1.52359 16.5199L1.52366 16.5201C2.45771 18.7033 4.1954 20.4429 6.37635 21.378C7.48952 21.8609 8.69089 22.1068 9.90409 22.0999Z"
                fill={color}
                stroke={color}
                strokeWidth="0.2"
            />
        </svg>
    );
}

TimerIcon.propTypes = propTypes;
TimerIcon.defaultProps = defaultProps;

export default TimerIcon;
